import { apiClient } from "@/lib/api";

const KEY = "maa_attr";

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

// Capture UTM/ref from the URL, persist, and register a visit once per session.
export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const fields = ["utm_source", "utm_campaign", "utm_ad", "ref"];
    const incoming = {};
    fields.forEach((f) => {
      const v = p.get(f);
      if (v) incoming[f] = v;
    });
    const stored = getAttribution();
    // First-touch: only overwrite if new params arrive
    const attr = Object.keys(incoming).length ? { ...stored, ...incoming } : stored;
    if (Object.keys(incoming).length) {
      localStorage.setItem(KEY, JSON.stringify(attr));
    }
    if (!sessionStorage.getItem("maa_visit_sent")) {
      sessionStorage.setItem("maa_visit_sent", "1");
      apiClient
        .post("/funnel/visit", {
          utm_source: attr.utm_source || null,
          utm_campaign: attr.utm_campaign || null,
          utm_ad: attr.utm_ad || null,
          ref: attr.ref || null,
          landing_url: window.location.href,
          referrer: document.referrer || null,
        })
        .then(({ data }) => {
          if (data?.visit_id) localStorage.setItem("maa_visit_id", data.visit_id);
        })
        .catch(() => {});
    }
  } catch {
    /* noop */
  }
}

export function funnelEvent(event, extra = {}) {
  const attr = getAttribution();
  apiClient
    .post("/funnel/event", {
      event,
      visit_id: localStorage.getItem("maa_visit_id") || null,
      utm_source: attr.utm_source || null,
      utm_campaign: attr.utm_campaign || null,
      utm_ad: attr.utm_ad || null,
      ref: attr.ref || null,
      ...extra,
    })
    .catch(() => {});
}
